import { ReactNode } from 'react';
import { useReduxState } from 'hooks';

interface Props {
  children: ReactNode;
  title: ReactNode;
}

const ProfileSummarySection = ({ children, title }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="section">
      <div className="title">{title}</div>
      <div className="content">{children}</div>

      <style jsx>{`
        .title {
          color: ${theme.textColorLight};
          font-weight: 700;
          font-size: 1.5rem;
          margin-bottom: 10px;
        }
      `}</style>
    </div>
  );
};

export default ProfileSummarySection;
